import React from "react";
import Tooltip from "../../../../common/components/tooltip";

/**
 * Shows a line's full description on hover.
 *
 * Description cells render an editable input, so anything longer than the column
 * simply scrolls out of sight -- and the merged / split lines this exists for are
 * always long. Used by both the work-order bill and the income/expense dialog so
 * the behaviour cannot drift between them.
 *
 * The tooltip hides on click, so it gets out of the way the moment the cell is
 * being edited, and disables itself when there is nothing to show.
 */
export default function DescriptionCellTooltip({value, children}) {
    const content = (value ?? '').toString().trim();

    return (
        <Tooltip
            content={<div className="whitespace-pre-wrap break-words text-left">{content}</div>}
            disabled={!content}
            hideOnClick={true}
            placement="top-start"
            delay={[400, 0]}
            maxWidth={420}
        >
            <div className="w-full min-w-0">
                {children}
            </div>
        </Tooltip>
    );
}
